import createDocumentStoreClass from './lib/create_document_store_class';
import LiveboardConverter from 'scripts/adapters/immutable_converters/liveboard_converter';

export default createDocumentStoreClass({
  converter: LiveboardConverter,
});



// WEBPACK FOOTER //
// ./src/scripts/adapters/stores/liveboard_store.js